import { Container, Tabs, Title } from '@mantine/core'
import { IconCalendarRepeat, IconCalendarStats, IconTemplate } from '@tabler/icons-react'
import { AppLayout } from '../features/projects/app-shell'
import { RecurringTab } from '../features/settings/recurring-tab'
import { HolidaysTab } from '../features/settings/holidays-tab'
import { TemplatesTab } from '../features/settings/templates-tab'

export function SettingsPage() {
  return (
    <AppLayout>
      <Container size="lg" py="md">
        <Title order={2} mb="md">
          Настройки
        </Title>
        <Tabs defaultValue="recurring" keepMounted={false}>
          <Tabs.List mb="lg">
            <Tabs.Tab value="recurring" leftSection={<IconCalendarRepeat size={16} />}>
              Регулярные задачи
            </Tabs.Tab>
            <Tabs.Tab value="holidays" leftSection={<IconCalendarStats size={16} />}>
              Праздники
            </Tabs.Tab>
            <Tabs.Tab value="templates" leftSection={<IconTemplate size={16} />}>
              Шаблоны онбординга
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="recurring">
            <RecurringTab />
          </Tabs.Panel>
          <Tabs.Panel value="holidays">
            <HolidaysTab />
          </Tabs.Panel>
          <Tabs.Panel value="templates">
            <TemplatesTab />
          </Tabs.Panel>
        </Tabs>
      </Container>
    </AppLayout>
  )
}
